import * as React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import {
  Typography,
  Box,
  Container,
  TextField,
  CssBaseline,
  Avatar,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Paper,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Tooltip,
  InputAdornment
} from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { connect } from "react-redux";
import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useNavigate,
  useParams
} from "react-router-dom";
import {
  centered_flex_box,
  MainInput,
  MainInputLabel,
  MainPassword,
  main_button,
  StyledInput,
  MainPhone,
  sec_button,
  left_flex_box
} from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";
import { isMobile } from "react-device-detect";
import { Button, notification, Space, Table, Tag } from "antd";
import {
  antTableCellWrapSx,
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "../../app/components/AntTableStyles";
import Logo from "../../app/components/logo.png";
import PropTypes from "prop-types";
import MuiPhoneNumber from "material-ui-phone-number";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
import ImageComponent from "../../app/components/ImageComponent";
import { editOrders, getOrders, getVendors, recreateOrder, resetOrder, setItemSoldOut } from "../../app/store/actions/imsAdminActions";
import { useEffect } from "react";
import { AddCircleOutline, Search } from "@mui/icons-material";
import moment from "moment/moment";
import OrdersTable from "../../app/components/OrdersTable";
import axios from "axios";
import download from "downloadjs";
import { downloadShippingAwbs, groupOrdersForAwbPrinting, parseAwbError } from "../../app/utils/shippingAwb";
import { getOrderCourierLabel, getOrderTrackingId } from "../../app/utils/shippingDisplay";

function isBlinkLate(confirmedAt) {
  if (!confirmedAt) {
    return false;
  }
  const shifted = new Date(Date.now() + 120 * 60 * 1000);
  const cutoff = Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth(), shifted.getUTCDate() - 1, 12, 0, 0) - (120 * 60 * 1000);
  return new Date(confirmedAt).getTime() <= cutoff;
}

export const PackingSystem = ({
  getOrders,
  editOrders,
  resetOrder,
  user,
  orders,
  blinkLateCount,
  setItemSoldOut,
  recreateOrder,
  warehouseId,
  isLoading,
  token,
  getVendors,
  vendors
}) => {
  const navigate = useNavigate();
  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [gettingAWB, setGettingAWB] = React.useState(false);
  const [action, setAction] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [vendorId, setVendorId] = React.useState(null);
  const [status, setStatus] = React.useState(null);
  const [activeTab, setActiveTab] = React.useState(0);
  const [search, setSearch] = React.useState('');
  const [appliedSearch, setAppliedSearch] = React.useState('');
  const { t, i18n } = useTranslation();

  const columns = [
    idTableColumn(),
    {
      title: 'Shopify Number',
      dataIndex: 'shopifyOrderNumber',
    },
    {
      title: 'Tracking ID',
      dataIndex: 'trackingId',
    },
    {
      title: 'Courier',
      dataIndex: 'courier',
    },
    {
      title: 'Date Ordered',
      dataIndex: 'date',
      sorter: (a, b) => { return moment(a.date).isBefore(b.date) ? -1 : 1 },
    },
    {
      title: 'Date Assigned',
      dataIndex: 'dateAssigned',
      sorter: (a, b) => { return moment(a.dateAssigned).isBefore(b.dateAssigned) ? -1 : 1 },
    },
    {
      title: 'Date Packed',
      dataIndex: 'dateFulfilled',
      sorter: (a, b) => { return moment(a.dateFulfilled).isBefore(b.dateFulfilled) ? -1 : 1 },
    },
    {
      title: 'Assigned Employee',
      dataIndex: 'assignee'
    },
    {
      title: 'Time to pack',
      dataIndex: 'time'
    },
    {
      title: 'Customer Name',
      dataIndex: 'customer',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (_, { status, late }) => <Space>
        <Tag color={status === "Delivered" ? "green" : status === "Cancelled" ? "red" : status === "Prepared" ? "blue" : "yellow"}>{status.toUpperCase()}</Tag>
        {late && <Tag color="red">LATE</Tag>}
      </Space>
    },
    {
      title: 'Vendor',
      dataIndex: 'vendor',
    },
    {
      title: 'Actions',
      render: (_, { status, date, _id }) => <Space>
        {status === "Prepared" && <Button onClick={() => verifyOrderPacked(_id)}>Verify Packed Order</Button>}
        {(status === "Preparing" || status === "Prepared") && <Button onClick={() => resetOrder({orderId: _id})}>Reset Order Packing</Button>}
        {status === "New" && moment().diff(moment(date), "days") >= 10 && <Button onClick={() => recreateOrder({orderId: _id})}>Recreate Order</Button>}
      </Space>
    },
  ];

  const data = orders?.docs?.map((row) => {
    return {
      _id: row._id,
      shopifyOrderNumber: row.shopifyOrderNumber,
      key: row._id,
      trackingId: getOrderTrackingId(row),
      courier: getOrderCourierLabel(row, row.vendor),
      date: moment(row.createdAt).format("lll"),
      dateFulfilled: row.preparedAt ? moment(row.preparedAt).format("lll") : null,
      dateAssigned: row.assignedAt ? moment(row.assignedAt).format("lll") : null,
      assignee: row.assignee ? row.assignee.name : null,
      time: row.preparedAt && row.assignedAt ? moment(moment(row.preparedAt).diff(moment(row.assignedAt), "seconds") * 1000).format("mm:ss") : null,
      status: row.status,
      late: isBlinkLate(row.confirmedAt),
      customer: row.orderFulfillment?.customer,
      vendor: row.vendor?.name ?? null,
      orderItems: row.orderItems,
    }
  });

  const expandedRowRender = (items) => {
    console.log(items)
    const columns = [
      {
        title: 'Product SKU',
        dataIndex: 'sku',
      },
      {
        title: 'Image',
        dataIndex: 'image',
        render: (text) => <ImageComponent width={50} height={50} src={text} preview={true} />,
      },
      {
        title: 'Name',
        dataIndex: 'name'
      },
      {
        title: 'Size',
        dataIndex: 'size',
      },
      {
        title: 'Color',
        dataIndex: 'color',
      },
      {
        title: 'Weight',
        dataIndex: 'weight',
      },
      {
        title: 'QTY Ordered',
        dataIndex: 'quantity',
      },
      {
        title: 'Actions',
        render: (_, { _id }) => <Space>
          <Button onClick={() => setItemSoldOut({orderItemId: _id})}>Mark as Sold Out</Button>
        </Space>
      },
    ];

    const data = items?.map((row) => {
      return {
        _id: row._id,
        sku: row.product.sku,
        inboundId: row._id,
        image: row.product.image,
        name: row.product.name,
        size: row.product.size,
        color: row.product.color,
        weight: row.product.weight,
        quantity: row.quantityOrdered,
      }
    })
    return (
      <Box sx={antTableCellWrapSx}>
        <Table columns={columns} dataSource={data} pagination={false} />
      </Box>
    );
  };

  const onSelectChange = (newSelectedRowKeys) => {
    console.log('selectedRowKeys changed: ', newSelectedRowKeys);
    setSelectedOrders(newSelectedRowKeys.map((key) => { return key }));
  };

  const rowSelection = {
    selectedOrders,
    onChange: onSelectChange,
  };

  const hasSelected = selectedOrders.length > 0;
  const isPrintedTab = activeTab === 1;
  const isBlinkTab = activeTab === 2;

  const getOrdersParams = (targetPage = page) => ({
    page: targetPage,
    limit: 50,
    isReturn: false,
    populateItems: true,
    status: isBlinkTab ? undefined : (status ? [status] : ["New", "Pending Confirmation", "Preparing", "Prepared"]),
    vendorId,
    ...(isBlinkTab ? { blinkPrep: "true" } : { printedAWB: activeTab === 1 }),
    search: appliedSearch || undefined,
    startDate: moment().subtract(3, "months").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });

  const handleSearch = () => {
    setAppliedSearch(search.trim());
    if (page !== 1) {
      setPage(1);
    }
    setSelectedOrders([]);
  };

  const markOrdersAsPrinted = (orderIds) => {
    return axios.get(`${process.env.REACT_APP_API_BASE}/IMAdmin/orders/print`, {
      params: { orderIds },
      headers: {
        "x-access-token": token
      }
    });
  };

  const handlePrintAWBs = async () => {
    const selectedOrderDocs = orders?.docs?.filter((order) => selectedOrders.includes(order._id)) || [];
    const { shipbluOrders, bostaOrders, fincartOrders, blinkOrders, fincartOrdersMissingId, fincartOrdersNotEligible } = groupOrdersForAwbPrinting(selectedOrderDocs);

    if (fincartOrdersMissingId.length > 0) {
      notification.warning({
        message: "Some Fincart orders are missing a valid Fincart order ID",
        description: "Recreate those orders before printing AWBs",
      });
    }

    if (fincartOrdersNotEligible.length > 0) {
      notification.warning({
        message: "Some Fincart orders are no longer eligible for AWB printing",
        description: "Fincart labels are only available for New or Pending Confirmation orders",
      });
    }

    if (shipbluOrders.length === 0 && bostaOrders.length === 0 && fincartOrders.length === 0 && blinkOrders.length === 0) {
      notification.warning({
        message: "No AWBs to print for selected orders"
      });
      return;
    }

    setGettingAWB(true);
    let printedSuccessfully = false;

    try {
      if (shipbluOrders.length > 0) {
        try {
          const data = await downloadShippingAwbs({
            token,
            apiBasePath: "IMAdmin",
            service: "ShipBlu",
            trackingNumbers: shipbluOrders,
          });
          download(data, "Shipblu Orders AWBs.pdf", "application/pdf");
          printedSuccessfully = true;
        } catch (error) {
          notification.error({
            message: "Error fetching Shipblu AWBs",
            description: parseAwbError(error, "ShipBlu"),
            style: {
              marginTop: "10vh"
            }
          });
        }
      }

      if (bostaOrders.length > 0) {
        try {
          const data = await downloadShippingAwbs({
            token,
            apiBasePath: "IMAdmin",
            service: "Bosta",
            trackingNumbers: bostaOrders,
          });
          download(data, "Bosta Orders AWBs.pdf", "application/pdf");
          printedSuccessfully = true;
        } catch (error) {
          notification.error({
            message: "Error fetching Bosta AWBs",
            description: parseAwbError(error, "Bosta"),
            style: {
              marginTop: "10vh"
            }
          });
        }
      }

      for (const fincartOrder of fincartOrders) {
        try {
          const data = await downloadShippingAwbs({
            token,
            apiBasePath: "IMAdmin",
            service: "Fincart",
            fincartOrderIds: [fincartOrder.fincartId],
          });
          download(data, `Fincart Order ${fincartOrder.label} AWB.pdf`, "application/pdf");
          printedSuccessfully = true;
        } catch (error) {
          notification.error({
            message: `Error fetching Fincart AWB for ${fincartOrder.label}`,
            description: parseAwbError(error, "Fincart"),
            style: {
              marginTop: "10vh"
            }
          });
        }
      }

      for (const blinkOrder of blinkOrders) {
        try {
          const data = await downloadShippingAwbs({
            token,
            apiBasePath: "IMAdmin",
            service: "Blink",
            blinkOrderIds: [blinkOrder.blinkId],
          });
          download(data, `Blink Order ${blinkOrder.label} AWB.pdf`, "application/pdf");
          printedSuccessfully = true;
        } catch (error) {
          notification.error({
            message: `Error fetching Blink AWB for ${blinkOrder.label}`,
            description: parseAwbError(error, "Blink"),
          });
        }
      }

      if (printedSuccessfully) {
        await markOrdersAsPrinted(selectedOrderDocs.map((order) => order._id));
        setSelectedOrders([]);
        getOrders(getOrdersParams());
      }
    } finally {
      setGettingAWB(false);
    }
  };

  const verifyOrderPacked = (orderId) => {
    editOrders({ orderId, edits: { status: "Ready for Pickup" } }, setAction, action)
  }

  useEffect(() => {
    getOrders(getOrdersParams())
  }, [page, action, vendorId, status, activeTab, appliedSearch])

  useEffect(() => {
    getVendors({ page: 1, limit: 100 })
  }, [])

  useEffect(() => {
    if(page === 1) {
      getOrders(getOrdersParams())
    } else {
      setPage(1)
    }
    setSelectedOrders([])
  }, [vendorId, status, activeTab])

  return (
    <div>
      <Box sx={{ width: "100%", padding: 5, mt: 2 }}>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Preparing Orders</Typography>
        </Box>
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Card sx={{ width: "100%", mb: 1 }}>
            <CardContent sx={{ pb: "8px !important" }}>
              <Tabs value={activeTab} onChange={(_, newValue) => setActiveTab(newValue)}>
                <Tab label="Not Yet Printed AWBs" />
                <Tab label="Printed AWBs" />
                <Tab label="Same Day (Blink)" />
              </Tabs>
            </CardContent>
          </Card>
        </Box>
        {isBlinkTab && blinkLateCount > 0 && (
          <Box sx={{ mb: 1 }}>
            <Typography sx={{ color: "var(--secColor)", fontWeight: 600 }}>
              {blinkLateCount} Blink order{blinkLateCount === 1 ? "" : "s"} confirmed at or before 12:00 yesterday and not yet picked up.
            </Typography>
          </Box>
        )}
        <Box sx={{ ...centered_flex_box, mb: 1 }}>
          <Card sx={{ width: "100%" }}>
            <CardContent>
              <Box sx={{ ...left_flex_box }}>
                <BrandSelect
                  vendors={vendors}
                  value={vendorId}
                  label="Filter by Vendor"
                  emptyLabel="All vendors"
                  autoFocus
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  onChange={(id) => setVendorId(id)}
                />
                <MainInput
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  margin="normal"
                  label="Filter by Status"
                  select
                  value={status}
                  onChange={({ target }) => { setStatus(target.value) }}
                >
                  <MenuItem value={null}>All Statuses</MenuItem>
                  <MenuItem value="New">New</MenuItem>
                  <MenuItem value="Pending Confirmation">Pending Confirmation</MenuItem>
                  <MenuItem value="Preparing">Preparing</MenuItem>
                  <MenuItem value="Prepared">Prepared</MenuItem>
                  <MenuItem value="Sold Out">Sold Out</MenuItem>
                </MainInput>
                <MainInput
                  sx={{ marginInlineEnd: 2, minWidth: "20vw" }}
                  margin="normal"
                  label="Search"
                  placeholder="Order number, tracking ID, or order ID"
                  value={search}
                  onChange={({ target }) => setSearch(target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={handleSearch} edge="end" sx={{ color: "var(--secColor4)" }}>
                          <Search />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            </CardContent>
          </Card>
        </Box>
        <Box sx={{ ...left_flex_box, mb: 2 }}>
          <Tooltip title={hasSelected ? `${isPrintedTab ? "Reprint" : "Print"} AWBs for selected orders` : `Select orders to ${isPrintedTab ? "reprint" : "print"} AWBs`}>
            <span>
              <Button 
                onClick={handlePrintAWBs} 
                type="primary" 
                disabled={!hasSelected} 
                loading={isLoading || gettingAWB}
                style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}
              >
                {isPrintedTab ? "Reprint AWBs" : "Print AWBs"}
              </Button>
            </span>
          </Tooltip>
          <Typography sx={{ ml: 1, fontWeight: 500 }}>
            {hasSelected ? `Selected ${selectedOrders.length} orders` : null}
          </Typography>
        </Box>
        <Box sx={antTableWrapperSx(isMobile)}>
          <Table
            columns={columns}
            dataSource={data}
            loading={isLoading}
            showSorterTooltip={{
              target: 'sorter-icon',
            }}
            expandable={{
              expandedRowRender: (record) => expandedRowRender(record.orderItems),
              rowExpandable: (record) => record.orderItems?.length > 0
            }}
            rowSelection={rowSelection}
            pagination={defaultPaginatedTableProps({
              current: page,
              pageSize: 50,
              total: orders?.totalDocs,
              onChange: (nextPage) => setPage(nextPage),
            })}
            scroll={{ x: isMobile ? 300 : 1200 }}
          />
        </Box>
      </Box>
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.records?.isLoading || state?.wait?.isLoading,
  token: state?.auth?.token,
  orders: state?.records?.orders,
  blinkLateCount: state?.records?.blinkLateCount || 0,
  vendors: state?.records?.vendors,
});

const mapDispatchToProps = { getOrders, editOrders, setItemSoldOut, recreateOrder, resetOrder, getVendors };

export default connect(mapStateToProps, mapDispatchToProps)(PackingSystem);
